// @flow
import * as general from './general'

// Types
import type { Props } from './general'

export const StyledButton = (props: Props) => {
  const { $color, $loading, $palette } = props
  const color = $palette($color).lighten(10)
  const darkenColor = color.clone().darken(20)
  const superDarkenColor = darkenColor.clone().darken(30)
  const loadingMod = $loading ? { opacity: 0.6 } : {}

  return {
    ...general.BasicButton(props),
    ...loadingMod,
    backgroundColor: 'transparent',
    fontSize: general.SIZES[props.$size] || general.SIZES.inherit,
    border: 'none',
    textDecoration: 'underline',
    padding: 0,
    textAlign: 'inherit',
    display: 'inline-flex',
    color: `${color}`,
    ':focus': {
      outline: 0,
      color: `${darkenColor}`,
    },
    ':hover': {
      color: `${darkenColor}`,
    },
    ':active': {
      color: `${superDarkenColor}`,
    },
    ':disabled': {
      opacity: 0.6,
    },
  }
}

export const ButtonText = {
  ...general.ButtonText,
  whiteSpace: 'normal',
}
